/* eslint-disable import/prefer-default-export */
export const ZIP_CODE_LENGTH = 5;
